export default __webpack_public_path__ + "static/media/add-button.e701f3f7.png";